import axios from 'axios';
import { API_URL } from './constants';

const api = axios.create({
  baseURL: `${API_URL}`,
});

api.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.request && !error.response) {
      // The request was made but no response was received
      console.warn('Request was made but no response received');
    } else if (!error.request && !error.response) {
      // Something happened in setting up the request that triggered an Error
      console.warn('Wrong setup of request');
    }
    return Promise.reject(error);
  }
);

export default api;
